import { inject, Injectable } from '@angular/core';
import { ServicesService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class WordListEndpointService {
  readonly #service = inject(ServicesService);

  wordLists() {
    return this.#service.vesta('wordlists');
  }
}
